import { Deserializable } from '../protocols/deserializable';
import { BaseType } from '../base/base-type';
import { VbAnnualDetailsProvenanceTypeEnum } from '../enum/shared/vb-annual-details-provenance-type.enum';

export class VbAccountAnnualDetails implements Deserializable {
  public id!: string;
  public effectiveYear!: number;
  // Estimated is last year's band carried forward until the year's own limits are worked out in early January
  public provenanceTypeId!: VbAnnualDetailsProvenanceTypeEnum;
  public provenanceType!: BaseType;
  public minimumAgeDateOfBirth!: string | null;
  public minimumAgeName!: string | null;
  public minimumAgeSpouseId!: number | null;
  public minimumAnnualWithdrawalAmount!: number;
  public maximumAnnualWithdrawalAmount!: number;
  // 0 unless an elected spouse's minimum was above the maximum, which is then raised to it
  public maximumRaisedToMinimumAmount!: number;

  public onDeserialize(): void {
    if (this.provenanceType) {
      this.provenanceType = window.injector.Deserialize.instanceOf(BaseType, this.provenanceType);
    }
  }
}
